import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { useRef } from 'react';
import InputWithLabel from '../../../component/common/InputWithLabel';
import { errorToast, isSuperAdmin, successToast } from '../../../utils/helper';
import toast from 'react-hot-toast';
// import { Api } from '../../../api';
import Loader from '../../../component/common/Loader';
import FormSelect from '../../../component/common/FormSelect';
import { ApiForRole } from '../challenges/ApiForRole';
import { DEPARTMENT } from '../../../utils/constants';
// import { successToast } from "../../../../utils//helper";

const numberOfWinners = [
  { id: 1, name: '01', value: '01' },
  { id: 2, name: '02', value: '02' },
  // { id: 3, name: '03', value: '03' },
  { id: 3, name: '03', value: '03' },
  { id: 4, name: '04', value: '04' },
  { id: 5, name: '05', value: '05' }
];

const initialDetailFormData = {
  _id: null,
  reward_title: '',
  number_of_winners: '',
  reward_image: '',
  image: null
};

const TaskRewardForm = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const queryparams = Object.fromEntries(searchParams);
  const view = queryparams.view || 'edit';
  const [loader, setloader] = useState(false);

  const location = useLocation();
  const state = location.state;
  console.log(state?._id, 'state_idddddd');

  const DetailsForm = () => {
    const [formData, setFormData] = useState(initialDetailFormData);
    const fileInputRef = useRef(null);
    const [imagePreview, setImagePreview] = useState('');
    const [selectedImage, setSelectedImage] = useState('');
    const handleImageChange = (e) => {
      if (e?.target?.files[0]?.size > 1048576) {
        errorToast(`File size should be less than 1MB`);
      } else {
        if (e?.target?.files[0]) {
          if (!e?.target?.files[0].name.match(/\.(jpg|jpeg|png|gif)$/i)) {
            errorToast(
              `The specified file ${e?.target?.files[0].name} could not be uploaded. Please upload valid image.`
            );
          } else {
            console.log('image', e.target.files[0]);
            setSelectedImage(e.target.files[0]);
            const objectUrl = URL.createObjectURL(e.target.files[0]);
            setFormData((prev) => ({
              ...prev,
              reward_image: objectUrl,
              image: e.target.files[0]
            }));
            setImagePreview(objectUrl);
            return () => URL.revokeObjectURL(objectUrl);
          }
        } else {
          setImagePreview(undefined);
        }
      }
    };

    const handleChange = (e) => {
      const { name, value } = e.target;
      setFormData((prev) => ({ ...prev, [name]: value }));
    };
    const handleContinue = async (statusID) => {
      // Validation
      if (!formData?.reward_title || !formData?.number_of_winners || !formData?.image) {
        if (!formData?.reward_title) toast.error('Reward is required');
        else if (!formData?.number_of_winners) toast.error('Winners is required');
        else if (!formData?.image) toast.error('Image is required');
        return;
      }
      // return
      const reqBody = {
        challengeId: state?._id,
        numberOfWinners: formData?.number_of_winners,
        reward: formData?.reward_title,
        image: formData?.image,
        selectTeam: formData?.selectTeam,
        status: statusID
      };
      try {
        setloader(true);
        await ApiForRole()
          .addChallengesReward(reqBody)
          .then((response) => {
            if (response?.status === 200) {
              successToast(response?.data?.message);
              navigate('/challenges/create-new-challenges?page=results', {
                state: {
                  _id: response?.data?.reward?.challengeId?._id
                }
              });
            }
          });
      } catch (error) {
        console.error('Error fetching get wellpoints count:', error);
      } finally {
        setloader(false);
      }
    };
    const handleChange2 = (name, value) => {
      setFormData((prev) => ({
        ...prev,
        [name]: value
      }));
    };

    const fetchList = async (id) => {
      // setloader(true);
      try {
        const response = await ApiForRole().getChallengesReward(id);
        const responseData = response?.data || {};

        if (responseData) {
          const urlToFile = async (url, filename = 'image.jpg') => {
            const res = await fetch(url);
            const blob = await res.blob();
            return new File([blob], filename, { type: blob.type });
          };

          let imageFile = null;
          let imagePreviewUrl = '';

          if (responseData?.reward?.image) {
            imageFile = await urlToFile(responseData.reward.image); // await here!
            imagePreviewUrl = URL.createObjectURL(imageFile);
          }

          setFormData({
            reward_title: responseData?.reward?.reward,
            number_of_winners: responseData?.reward?.numberOfWinners,
            reward_image: '',
            image: imageFile,
            selectTeam: responseData?.reward?.selectTeam
          });

          setImagePreview(imagePreviewUrl); // Show preview image
          setSelectedImage(imageFile); // Set for form submit
        }
      } catch (error) {
        console.error('Error fetching get wellpoints count:', error);
      } finally {
        // setloader(false);
      }
    };

    useEffect(() => {
      if (state?._id) {
        fetchList(state?._id);
      }
    }, [state?._id]);

    return (
      <div className="mt-5">
        {loader ? <Loader /> : null}
        <div className="h-full p-6 bg-white dark:bg-shoorah-darkBgTabColor dark:border-none border-[1.5px] border-shoorah-borderGray lg:rounded-2xl rounded-xl">
          <div className="flex justify-between items-center mb-4">
            <h3 className="font-medium text-xl">Add custom reward (Also optional)</h3>
          </div>
          <div className="h-full flex flex-col md:flex-row items-start md:gap-4 gap-2 max-w-[800px]  
          border-b-[1px] border-[#E7E8EA] pb-[20px]">
            {/* Image Upload start */}
            <div className='w-[82px]'>
              <input
                type="file"
                accept=".jpg, .jpeg, .png"
                className="hidden"
                ref={fileInputRef}
                onChange={handleImageChange}
              />

              <div
                onClick={() => fileInputRef.current.click()} // Click div to open file input
                className="flex justify-center mt-3 items-center overflow-hidden rounded-[9px] 
                                border-[1.5px] border-[#B6C0F3] border-dashed dark:border-shoorah-darkBgColor
                                 w-[82px] h-[82px] bg-[#E5EAF9] dark:bg-shoorah-darkBgColor relative cursor-pointer"
              >
                {/* {console.log('image preview', imagePreview)} */}
                {imagePreview ? (
                  <img
                    src={imagePreview}
                    alt="Selected"
                    className="absolute w-full h-full object-cover rounded-[9px]"
                  />
                ) : (
                  <div className="flex flex-col justify-center items-center">
                    <svg
                      className="mb-2 text-shoorah-primary"
                      width="22"
                      height="22"
                      viewBox="0 0 23 22"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M8.89999 20.0445H14.3667C18.9222 20.0445 20.7444 18.2223 20.7444 13.6667V8.20004C20.7444 3.64449 18.9222 1.82227 14.3667 1.82227H8.89999C4.34444 1.82227 2.52222 3.64449 2.52222 8.20004V13.6667C2.52222 18.2223 4.34444 20.0445 8.89999 20.0445Z"
                        fill="#B6C0F3"
                        stroke="#313B6B"
                        strokeWidth="1.36667"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M8.90004 9.11124C9.90643 9.11124 10.7223 8.2954 10.7223 7.28902C10.7223 6.28263 9.90643 5.4668 8.90004 5.4668C7.89366 5.4668 7.07782 6.28263 7.07782 7.28902C7.07782 8.2954 7.89366 9.11124 8.90004 9.11124Z"
                        fill="#B6C0F3"
                        stroke="#313B6B"
                        strokeWidth="1.36667"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M3.13263 17.2652L7.62441 14.2494C8.34418 13.7665 9.38285 13.8212 10.0297 14.3769L10.3304 14.6412C11.0411 15.2516 12.1891 15.2516 12.8997 14.6412L16.69 11.3885C17.4006 10.7781 18.5486 10.7781 19.2593 11.3885L20.7444 12.6641"
                        fill="#B6C0F3"
                      />
                      <path
                        d="M3.13263 17.2652L7.62441 14.2494C8.34418 13.7665 9.38285 13.8212 10.0297 14.3769L10.3304 14.6412C11.0411 15.2516 12.1891 15.2516 12.8997 14.6412L16.69 11.3885C17.4006 10.7781 18.5486 10.7781 19.2593 11.3885L20.7444 12.6641"
                        stroke="#313B6B"
                        strokeWidth="1.36667"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                )}
              </div>
              {selectedImage && (
                <p
                  className="mt-2 text-xs text-gray-600 break-all"
                  style={{
                    display: '-webkit-box',
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: 'vertical',
                    overflow: 'hidden',
                  }}
                >
                  Selected: {selectedImage?.name} ({Math.round(selectedImage?.size / 1024)} KB)
                </p>
              )}
            </div>
            <div className="flex w-full items-end md:h-[92px] max-w-[700px] gap-4 flex-wrap">
              <div className="flex-1 min-w-[200px]">
                <InputWithLabel
                  label={'Reward'}
                  placeholder={'Example... qualify to win a'}
                  containerClassName=""
                  onChange={handleChange}
                  value={formData?.reward_title}
                  name={'reward_title'}
                  disabled={view === 'preview' || view === 'preview_only'}
                />
              </div>
              <div className="flex-1 min-w-[200px]">
                <FormSelect
                  key={formData.number_of_winners}
                  label={'Winners'}
                  options={numberOfWinners}
                  name={'number_of_winners'}
                  onChange={handleChange2}
                  value={formData?.number_of_winners || ''}
                  placeholder={'No. of winners'}
                  disabled={view === 'preview' || view === 'preview_only'}
                />
              </div>
            </div>
          </div>
        </div>

        {isSuperAdmin() ? "" :

          <div className="mt-5 h-full p-6 bg-white dark:bg-shoorah-darkBgTabColor dark:border-none border-[1.5px] border-shoorah-borderGray lg:rounded-2xl rounded-xl">
            {/* <div className="flex justify-between items-center mb-4">
            <h3 className="font-medium text-xl">Select Team</h3>
          </div> */}
            <div className="h-full flex flex-col md:flex-row items-start md:gap-4 gap-2 max-w-[800px] pb-[14px]">
              <div className="flex w-full items-end md:h-[92px] gap-4 flex-wrap">
                <div className="flex-1 w-full">
                  <FormSelect
                    key={formData.selectTeam}
                    label={'Select Team'}
                    options={DEPARTMENT}
                    name={'selectTeam'}
                    onChange={handleChange2}
                    value={formData?.selectTeam || ''}
                    placeholder={'Select Team(s)'}
                    disabled={view === 'preview' || view === 'preview_only'}
                  />
                </div>
              </div>
            </div>
            <div className="flex justify-start items-center mb-4">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22Z"
                  stroke="#0B1D2E"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M7.75 11.9999L10.58 14.8299L16.25 9.16992"
                  stroke="#0B1D2E"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              <h3 className="font-medium text-[14px] ms-2">All Staff Members</h3>
            </div>
          </div>
        }


        <div className="flex justify-end mt-6">
          <div className="mr-3 self-center">
            <button
              type="button"
              onClick={() => handleContinue(0)}
              className="text-sm px-5 h-[40px] rounded-full border border-[#0B1D2E] bg-[#f4f4f4] text-[#0B1D2E]"
            >
              Save as Template
            </button>
          </div>
          <button
            onClick={() => handleContinue(1)}
            type="button"
            className="inline-flex text-xs sm:text-base font-medium items-center justify-center rounded-3xl border bg-shoorah-secondary px-5 py-2 text-white hover:shoorah-primary focus:outline-none w-full sm:w-auto"
          >
            Publish Challenge
            {/* <img className="ml-2" src={RightArrow} alt="edit" /> */}
          </button>
        </div>
      </div>
    );
  };

  return (
    <div>
      <DetailsForm />
    </div>
  );
};

export default TaskRewardForm;